export const fontFamily = {
  base: "'Pretendard JP Variable', 'Pretendard JP', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Hiragino Sans', 'Apple SD Gothic Neo', Meiryo, 'Noto Sans JP', 'Noto Sans KR', 'Malgun Gothic', Osaka, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', sans-serif",
} as const

export const typographyVariants = {
  // Display
  'Display/display-40-bold': {
    fontSize: '2.5rem',
    lineHeight: '130%',
    fontWeight: 700,
    letterSpacing: '0px',
  },
  'Display/display-32-bold': {
    fontSize: '2rem',
    lineHeight: '130%',
    fontWeight: 700,
    letterSpacing: '0px',
  },
  'Display/display-24-bold': {
    fontSize: '1.5rem',
    lineHeight: '130%',
    fontWeight: 700,
    letterSpacing: '0px',
  },

  // Heading
  'Heading/Heading-24-bold': {
    fontSize: '1.5rem',
    lineHeight: '130%',
    fontWeight: 700,
    letterSpacing: '0px',
  },
  'Heading/Heading-18-bold': {
    fontSize: '1.125rem',
    lineHeight: '130%',
    fontWeight: 700,
    letterSpacing: '0px',
  },
  'Heading/Heading-16-bold': {
    fontSize: '1rem',
    lineHeight: '130%',
    fontWeight: 700,
    letterSpacing: '0px',
  },
  'Heading/Heading-14-bold': {
    fontSize: '0.875rem',
    lineHeight: '130%',
    fontWeight: 700,
    letterSpacing: '0px',
  },
  'Heading/Heading-24-Semibold': {
    fontSize: '1.5rem',
    lineHeight: '130%',
    fontWeight: 600,
    letterSpacing: '0px',
  },
  'Heading/Heading-22-semibold': {
    fontSize: '1.375rem',
    lineHeight: '130%',
    fontWeight: 600,
    letterSpacing: '0px',
  },
  'Heading/Heading-20-Semibold': {
    fontSize: '1.25rem',
    lineHeight: '130%',
    fontWeight: 600,
    letterSpacing: '0px',
  },
  'Heading/Heading-18-Semibold': {
    fontSize: '1.125rem',
    lineHeight: '130%',
    fontWeight: 600,
    letterSpacing: '0px',
  },
  'Heading/Heading-16-Semibold': {
    fontSize: '1rem',
    lineHeight: '130%',
    fontWeight: 600,
    letterSpacing: '0px',
  },
  'Heading/Heading-14-Semibold': {
    fontSize: '0.875rem',
    lineHeight: '130%',
    fontWeight: 600,
    letterSpacing: '0px',
  },
  'Heading/Heading-16-medium': {
    fontSize: '1rem',
    lineHeight: '130%',
    fontWeight: 500,
    letterSpacing: '0px',
  },
  'Heading/Heading-14-medium': {
    fontSize: '0.875rem',
    lineHeight: '130%',
    fontWeight: 500,
    letterSpacing: '0px',
  },
  'Heading/Heading-14-regular': {
    fontSize: '0.875rem',
    lineHeight: '130%',
    fontWeight: 400,
    letterSpacing: '0px',
  },

  // Body
  'Body/Body-16-medium': {
    fontSize: '1rem',
    lineHeight: '130%',
    fontWeight: 500,
    letterSpacing: '0px',
  },
  'Body/Body-14-medium': {
    fontSize: '0.875rem',
    lineHeight: '130%',
    fontWeight: 500,
    letterSpacing: '0px',
  },
  'Body/Body-12-medium': {
    fontSize: '0.75rem',
    lineHeight: '130%',
    fontWeight: 500,
    letterSpacing: '0px',
  },
  'Body/Body-16-regular': {
    fontSize: '1rem',
    lineHeight: '130%',
    fontWeight: 400,
    letterSpacing: '0px',
  },
  'Body/Body-14-regular': {
    fontSize: '0.875rem',
    lineHeight: '130%',
    fontWeight: 400,
    letterSpacing: '0px',
  },
  'Body/Body-12-regular': {
    fontSize: '0.75rem',
    lineHeight: '130%',
    fontWeight: 400,
    letterSpacing: '0px',
  },

  'Button/Button-16-Semibold': {
    fontSize: '1rem',
    lineHeight: '100%',
    fontWeight: 600,
    letterSpacing: '0px',
  },
  'Button/Button-16-medium': {
    fontSize: '1rem',
    lineHeight: '100%',
    fontWeight: 500,
    letterSpacing: '0px',
  },
  'Button/Button-12-semibold': {
    fontSize: '0.75rem',
    lineHeight: '100%',
    fontWeight: 600,
    letterSpacing: '0px',
  },
  'Button/Button-12-medium': {
    fontSize: '0.75rem',
    lineHeight: '100%',
    fontWeight: 500,
    letterSpacing: '0px',
  },
} as const

export type TypographyVariant = keyof typeof typographyVariants
export type Typography = typeof typographyVariants
